import { render, staticRenderFns } from "./FormWelcome.vue?vue&type=template&id=a4a6651a&scoped=true"
import script from "./FormWelcome.vue?vue&type=script&lang=js"
export * from "./FormWelcome.vue?vue&type=script&lang=js"
import style0 from "./FormWelcome.vue?vue&type=style&index=0&id=a4a6651a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a4a6651a",
  null
  
)

export default component.exports